import React from 'react';
import { createMergingContextProvider } from './helpers';
export const overlayContextDefaults = {
    showOverlay: true,
    showFaveControl: true,
    showCommentControl: true,
    showAuthor: true,
    showOwner: true,
    showPremiumFolderOverlay: true,
    showPremiumFolderIcon: true,
    showSubscriberOverlay: true,
    showSubscriberIcon: true,
    showSuggestedReasonLabel: true,
    showDailyDeviationLabel: true,
    showHypeLabel: true,
    showTitle: true,
    showStats: true,
    showAuthorName: true,
    showOwnerName: true,
    showExtraActions: true,
    showThumbStatusIndicators: true,
    showMediaIndicators: true,
    showMlt: true,
    showAwardBadge: true,
    showAuthorWatchButton: true,
    showOwnerWatchButton: true
};
export const OverlayContext = React.createContext(overlayContextDefaults);
OverlayContext.displayName = 'OverlayContext';
export const OverlayContextProvider = createMergingContextProvider(OverlayContext);

//# sourceMappingURL=OverlayContext.js.map